module.exports = __webpack_public_path__ + "static/media/bubble_1.2633b5d2.png";